<!--  -->
<template>
  <div>
    <!-- 筛选区域 -->
    <el-form
      :inline="true"
      :model="query"
      class="filter-form"
    >
      <el-form-item label="小说名称：">
        <el-input
          v-model="query.novel_name"
          placeholder="请输入小说名称"
          clearable
          style="width: 220px"
        />
      </el-form-item>
      <el-form-item label="备注：">
        <el-input
          v-model="query.remark"
          placeholder="请输入备注"
          clearable
          style="width: 220px"
        />
      </el-form-item>
      <el-form-item label="小说类型：">
        <el-select
          v-model="query.lable_type"
          placeholder="请选择"
          clearable
          style="width: 160px"
          :disabled="xiaoshuotype == 1 || xiaoshuotype == 3"
        >
          <el-option label="清水" :value="1" />
          <el-option label="擦边" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="小说状态：">
        <el-select
          v-model="query.auditing_status"
          placeholder="请选择"
          clearable
          style="width: 160px"
        >
          <el-option label="未提审" :value="0" />
          <el-option label="审核中" :value="1" />
          <el-option label="审核驳回" :value="2" />
          <el-option label="审核通过" :value="3" />
          <el-option label="上传失败" :value="8" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="650"
    >
      <el-table-column
        prop="novel_name"
        label="小说名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="novel_no"
        label="编号"
        width="180"
        align="center"
      />
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        min-width="80"
      >
        <template slot-scope="scope">
          <div class="remark-cell">
            <template v-if="isEditingRemark(scope.row)">
              <el-input
                v-model="remarkEditValue"
                size="mini"
                clearable
                placeholder="请输入备注"
                class="remark-input"
                @blur="submitRemarkOnBlur(scope.row)"
                @keyup.enter.native="submitRemarkOnBlur(scope.row)"
              />
            </template>
            <template v-else>
              <span class="remark-text" :title="scope.row.remark || ''">
                {{ scope.row.remark || '-' }}
              </span>
              <!-- <el-button
                type="text"
                class="remark-edit-btn"
                @click="startRemarkEdit(scope.row)"
              >
                <i class="el-icon-edit" />
              </el-button> -->
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="小说类型" align="center" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.lable_type == 1" style="padding: 2px;background-color: #E8F3FF;color: #87AEFF;">
            {{ scope.row.lable_type_text }}
          </div>
          <div v-else style="padding: 2px;background-color: #FFF3E8;color: #F89362;">
            {{ scope.row.lable_type_text }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="auditing_status_text"
        label="小说状态"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.auditing_status == 3" style="padding: 2px;background-color: #E8FFEA;color: #8FE2A0;">
            {{ scope.row.auditing_status_text }}
          </div>
          <div v-else style="padding: 2px;background-color: #F2F3F5;color: #818994;">
            {{ scope.row.auditing_status_text }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="novel_cover"
        label="封面"
        align="center"
      >
        <template #default="{ row }">
          <el-image
            :src="row.novel_cover"
            :preview-src-list="[row.novel_cover]"
            fit="cover"
            style="width: 80px; height: 110px; border-radius: 6px;"
            lazy
          >
            <div slot="error" class="img-placeholder">无图</div>
            <div slot="loading" class="img-loading">加载中...</div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="novel_no"
        label="操作"
        width="280"
        align="center"
      >
        <!-- <template slot-scope="scope">
          <el-button type="primary" :disabled="!scope.row.is_ok" @click="chooser(scope.row)">选择</el-button>
        </template> -->
        <template slot-scope="scope">
          <el-button type="info" size="small" @click="viewChapter(scope.row)">查看章节内容</el-button>
          <el-tooltip v-if="!scope.row.is_ok" content="小说未提审" placement="top">
            <el-button type="primary" size="small" :disabled="true">选择</el-button>
          </el-tooltip>
          <el-button v-else type="primary" size="small" @click="chooser(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :page-sizes="[10]"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <!-- 章节列表弹窗 -->
    <el-dialog
      title="章节列表"
      :visible.sync="chapterDialogVisible"
      :append-to-body="true"
      width="80%"
      :close-on-click-modal="false"
    >
      <chapter-list-dialog ref="chapterListDialog" />
    </el-dialog>
  </div>
</template>

<script>
import { promotionlinklist, novelRemark } from '@/api/miniProgramPhotoGallery.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ChapterListDialog from './chapterlistdialog.vue'
export default {
  components: { PaginationRight, ChapterListDialog },
  data() {
    return {
      tableData: [],
      appid: '',
      chapterDialogVisible: false,
      remarkEditingNovelNo: '',
      remarkEditValue: '',
      remarkOriginalValue: '',
      remarkSaving: false,
      query: {
        page: 1,
        pageSize: 10,
        novel_name: '',
        remark: '',
        lable_type: null,
        auditing_status: null
      },
      total: null,
      xiaoshuotype: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sendr(appid, xiaoshuotype) {
      console.log('appid', appid)
      this.appid = appid
      this.xiaoshuotype = xiaoshuotype
      // eslint-disable-next-line eqeqeq
      if (this.xiaoshuotype === 1) {
        this.query.lable_type = 1
      } else if (this.xiaoshuotype === 3) {
        this.query.lable_type = 2
      } else {
        this.query.lable_type = null
      }
      this.list()
    },
    list() {
      promotionlinklist({ app_id: this.appid, ...this.query }).then((res) => {
        this.tableData = res.data.list
        this.total = res.data.total
        console.log('res', res)
      })
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    // 搜索
    handleSearch() {
      this.query.page = 1
      this.list()
    },
    // 重置
    handleReset() {
      // eslint-disable-next-line eqeqeq
      if (this.xiaoshuotype == 1 || this.xiaoshuotype == 3) {
        this.query = {
          page: 1,
          pageSize: 10,
          novel_name: '',
          remark: '',
          lable_type: 1,
          auditing_status: null
        }
        this.list()
      } else {
        this.query = {
          page: 1,
          pageSize: 10,
          novel_name: '',
          remark: '',
          lable_type: null,
          auditing_status: null
        }
        this.list()
      }
    },
    chooser(item) {
      this.$emit('callnovel', item)
    },
    // 查看章节内容
    viewChapter(row) {
      this.chapterDialogVisible = true
      this.$nextTick(() => {
        this.$refs.chapterListDialog.open(row.novel_no, row.novel_name)
      })
    },
    // 备注：是否在编辑
    isEditingRemark(row) {
      return this.remarkEditingNovelNo && row.novel_no === this.remarkEditingNovelNo
    },
    // 备注：开始编辑
    startRemarkEdit(row) {
      this.remarkEditingNovelNo = row.novel_no
      this.remarkEditValue = row.remark || ''
      this.remarkOriginalValue = row.remark || ''
    },
    // 备注：取消编辑
    cancelRemarkEdit() {
      this.remarkEditingNovelNo = ''
      this.remarkEditValue = ''
      this.remarkOriginalValue = ''
    },
    // 备注：失焦提交（带确认弹窗）
    submitRemarkOnBlur(row) {
      if (!this.isEditingRemark(row)) return
      if (this.remarkSaving) return

      const nextVal = (this.remarkEditValue || '').trim()
      const originVal = (this.remarkOriginalValue || '').trim()
      // 未变化：直接退出编辑
      if (nextVal === originVal) {
        this.cancelRemarkEdit()
        return
      }

      this.$confirm('此操作将更新备注, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.remarkSaving) return
        this.remarkSaving = true
        novelRemark({
          novel_no: row.novel_no,
          remark: nextVal
        }).then(() => {
          row.remark = nextVal
          this.$message.success('备注已更新')
          this.cancelRemarkEdit()
        }).finally(() => {
          this.remarkSaving = false
        })
      }).catch(() => {
        // 取消：回滚并退出编辑
        this.remarkEditValue = this.remarkOriginalValue
        this.cancelRemarkEdit()
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.filter-form {
  margin-bottom: 16px;
}
.remark-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.remark-text {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
.remark-input {
  width: 200px;
}
.remark-edit-btn {
  padding: 0 4px;
}
.img-placeholder, .img-loading {
  width: 80px;
  height: 110px;
  display:flex;
  align-items:center;
  justify-content:center;
  background:#f5f7fa;
  color:#999;
  border-radius:6px;
  font-size:12px;
}
</style>
